import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../services/api';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!username.trim() || !password.trim()) {
      setError('Username aur password dono zaroori hain');
      return;
    }
    setLoading(true);
    try {
      const res = await authAPI.login(username.trim(), password);
      const { token, user } = res.data;

      // Verify this is a branch manager / super admin
      if (user.role !== 'branch_manager' && user.role !== 'super_admin') {
        setError('Aapke paas is portal ka access nahi hai');
        setLoading(false);
        return;
      }

      login(user, token);
      navigate('/');
    } catch (err) {
      const msg = err.response?.data?.message || 'Login failed. Please check credentials.';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-card">
        <div className="text-center mb-4">
          <div className="login-logo">🏪</div>
          <h4 style={{ color: 'var(--brand-primary)', fontWeight: 700, marginBottom: 4 }}>
            A2zTak Etawah Branch
          </h4>
          <p style={{ color: '#888', fontSize: 14, margin: 0 }}>Manager Portal</p>
        </div>

        {error && (
          <div className="alert alert-danger alert-dismissible py-2 px-3 mb-3" style={{ borderRadius: 8, fontSize: 14 }}>
            {error}
            <button type="button" className="btn-close btn-sm" onClick={() => setError('')} />
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label">Username</label>
            <input
              type="text"
              className="form-control"
              placeholder="etawah_manager"
              value={username}
              onChange={e => setUsername(e.target.value)}
              autoFocus
              autoComplete="username"
            />
          </div>
          <div className="mb-4">
            <label className="form-label">Password</label>
            <input
              type="password"
              className="form-control"
              placeholder="••••••••"
              value={password}
              onChange={e => setPassword(e.target.value)}
              autoComplete="current-password"
            />
          </div>
          <button
            type="submit"
            className="btn w-100 py-2"
            style={{ background: 'var(--brand-primary)', color: '#fff', borderRadius: 10, fontWeight: 600, fontSize: 16 }}
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" />
                Login ho raha hai...
              </>
            ) : 'Login Karein'}
          </button>
        </form>

        <div className="text-center mt-4" style={{ fontSize: 13, color: '#aaa' }}>
          A2zTak Multi-Branch System
        </div>
      </div>
    </div>
  );
}
